import { Suspense, useEffect, useState } from 'react';

const DynamicIcon = ({ iconName, innerProps }) => {
	const [IconComponent, setIconComponent] = useState(null);

	useEffect(() => {
		const loadIcon = async () => {
			try {
				// eslint-disable-next-line @next/next/no-assign-module-variable
				const module = await import(`iconsax-react`);
				setIconComponent(() => module[iconName]);
			} catch (error) {
				// console.error(`Failed to load icon: ${iconName}`, error);
			}
		};

		loadIcon();
	}, [iconName]);

	if (!IconComponent) {
		return <div></div>;
	}

	return (
		<Suspense fallback={<></>}>
			<IconComponent {...innerProps} />
		</Suspense>
	);
};

export default DynamicIcon;
